export const TABS = [
	{
		tabName: 'โปรไฟล์โรงงาน',
		key: 'account-info',
		path: '/profile/account-info',
	},
	{
		tabName: 'Images',
		key: 'images',
		path: '/profile/images',
	},
	{
		tabName: 'ข้อมูลทางธุรกิจ',
		key: 'business-info',
		path: '/profile/business-info',
	},
	{
		tabName: 'ข้อมูลทางธนาคาร',
		key: 'bank-info',
		path: '/profile/bank-info',
	},
	{
		tabName: 'บัญชีของฉัน',
		key: 'user-profile',
		path: '/profile/user-profile',
	},
	{
		tabName: 'จัดการผู้ใช้งาน',
		key: 'users',
		path: '/profile/users',
	},
	{
		tabName: 'โลจิสติกส์',
		key: 'logistic',
		path: '/profile/logistic',
	},
	{
		tabName: 'Plan',
		key: 'plan',
		path: '/profile/plan',
	},
	{
		tabName: 'Notification',
		key: 'notifications',
		path: '/profile/notifications',
	},
	{
		tabName: 'Certificates',
		key: 'certificates',
		path: '/profile/certificates',
	},
	{
		tabName: 'Supplier Features',
		key: 'supplier-features',
		path: '/profile/supplier-features',
	},
]

export const PLANS = [
	{
		planImg: '/media/icons/kumopack/layers-two-01.svg',
		planName: 'Basic',
		planPrice: '0',
		planDescription: 'Includes up to 10 users, 20GB individual data and access to all features.',
	},
	{
		planImg: '/media/icons/kumopack/layers-two-01.svg',
		planName: 'Business plan',
		planPrice: '299',
		planDescription: 'Includes up to 20 users, 40GB individual data and access to all features.',
	},
	{
		planImg: '/media/icons/kumopack/layers-three-01.svg',
		planName: 'Enterprise plan',
		planPrice: '599',
		planDescription: 'Unlimited users, unlimited individual data and access to all features.',
	},
]

export const PLAN_DETAILS = [
	{
		color: 'base-black',
		canPurchase: false,
		planName: 'Basic',
		planPrice: '0',
		planPriceDescription: 'Free Forever',
		planDescription: 'Includes up to 10 users, 20GB individual data and access to all features.',
		listHeader: 'Manage tasks and personal-to-dos:',
		lists: ['Capability 1', 'Capability 2', 'Capability 3', 'Capability 4', 'Capability 5'],
	},
	{
		color: 'secondary-600',
		canPurchase: true,
		planName: 'Business plan',
		planPrice: '299',
		planPriceDescription: 'Per user, per month billed annually 299฿ billed monthly',
		planDescription: 'Includes up to 20 users, 40GB individual data and access to all features.',
		listHeader: 'Track team projects with features and resources like:',
		lists: [
			'Capability 1',
			'Capability 2',
			'Capability 3',
			'Capability 4',
			'Capability 5',
			'Capability 6',
			'Capability 7',
			'Capability 8',
		],
	},
	{
		color: 'primary-600',
		canPurchase: true,
		planName: 'Enterprise plan',
		planPrice: '599',
		planPriceDescription: 'Per user, per month billed annually 599฿ billed monthly',
		planDescription: 'Unlimited users, unlimited individual data and access to all features.',
		listHeader: 'Everything in Enterprise, plus:',
		lists: [
			'Capability 1',
			'Capability 2',
			'Capability 3',
			'Capability 4',
			'Capability 5',
			'Capability 6',
			'Capability 7',
			'Capability 8',
			'Capability 9',
			'Capability 10',
		],
	},
]
